import React, { useState } from 'react'
import $ from 'jquery'
import Popup from '../../../components/Popup/Popup';
import NewOverlayLoader from '../../../components/PurchaseRequisition/common/NewOverlayLoader';
import Input from '../../../components/Forms/Input';
import Api from '../../../inc/Api';
import Helper from '../../../inc/Helper';
import Settings from '../../../inc/Settings';
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Button from '../../../components/inc/Button';

const ExportDataPopup = ({ apiUrl, apiPayload, apiColumnHeaders, setExportDataDetails }) => {
    const [userEmail, setUserEmail] = useState('');
 
    const [apiCallBtn, setApiCallBtn] = useState(false);

    const onClosePopupHandler = () => {
        setExportDataDetails({ openPopup: false, apiPayload: {}, apiColumnHeaders: [] });
        $('.export_data_popup_wrapper .rs_popup_close').trigger('click');
    };

    const onInputChange = (e) => {
        const { value } = e.target;
        setUserEmail(value);
    };

    const onSendBtnClick = () => {
        if(!userEmail) {
            Helper.alert('Please provide email', 'error');
            return;
        };

        setApiCallBtn(true);

        let api = Api
        api.setUserToken()
        api.axios().post(Settings.apiUrl+`/export_data`, {
            "api_link": apiUrl, 
            "api_payload": apiPayload,
            "column_names": apiColumnHeaders,
            "email_address": userEmail,
            "api_method": "post"
        }
        ).then(function(res){
            if(res.data.status==="success"){ 
                Helper.alert(res?.data?.message);
                setApiCallBtn(false);
                onClosePopupHandler();
            }
        }).catch((err) => {
            getPopupMessageBasedOnStatus(err);
            setApiCallBtn(false);
        });
    };

    return (
        <div className='export_data_popup_wrapper'>
            <Popup autoOpen={true} width={"400px"} onClose={onClosePopupHandler}>
                {apiCallBtn ? <NewOverlayLoader isPopupInTab={true} /> : null}
                
                <>
                    <h5 className="create_rfq_modal__title">Export Data To Email</h5>

                    <div className='container-fluid mt-4 mb-3'>
                        <div className='row'>
                            <div className='col-12'>
                                <Input required={true} label={ "Email" } type='email' onChange={onInputChange} value={userEmail} />
                            </div>
                        </div>
                    </div>
                </>

                <div className="addDocumentNumber-body-buttons" style={{ justifyContent: "flex-end" }}>
                    <Button
                        isActive={false} 
                        isDisable={apiCallBtn}
                        className='black-btn-style'
                        title={ "Close" }
                        onClick={onClosePopupHandler}
                    />
                    <Button
                        isDisable={apiCallBtn}
                        className="solid_btn" 
                        isActive={true}
                        title={ "Send Email" }
                        onClick={onSendBtnClick}
                    />
                </div>
            </Popup>
        </div>
    )
}

export default ExportDataPopup;